import * as _ from 'lodash'
import React from 'react';
import componentServices from '../componentServices';
import * as actions from '../actions';

import OrderDeskJobs from './orderDeskJobs';
import OrderDeskLeadTimes from './orderDeskLeadTimes';

class OrderDeskHeader extends React.Component<any,any> {
	handleRouteClick (key, e) {
		e.preventDefault();
		componentServices.router.pushHistory(componentServices.router.replacePathSegmentAt(1, key, true));
	}

	render () {
		const items:JSX.Element[] = [];
		const buttons = [{
			path: 'jobs',
			name: 'Queue'
		}, {
			path: 'lead-times',
			name: 'Lead Times'
		}];

		_.forEach(buttons, x => {
			let className = 'button';

			// TODO: deal with possible disabled status of header links
			className += (componentServices.router.isActive('order-desk', x.path)) ? ' on' : '';

			items.push(<li key={x.path}><a onClick={this.handleRouteClick.bind(this, x.path)} className={className}><span>{x.name}</span></a></li>);
		});

		return (
			<header>
				<ul className="menu">
					{ items }
				</ul>
			</header>
		);
	}
}

class OrderDeskModule extends React.Component<any,any> {
	componentDidMount () {
		actions.setHeader({
			key: 'orderDeskModuleHeader',
			element: (
				<OrderDeskHeader key={'orderDeskModuleHeader'} />
			)
		});
	}

	componentWillUnmount () {
		actions.deleteHeader({ key: 'orderDeskModuleHeader' });
	}

	render () {
		const { children } = this.props;

		return children;
	}
}

componentServices.router.addRoutes([{
	path: '/order-desk/jobs',
	component: ({ ...props }) => <OrderDeskModule { ...props}><OrderDeskJobs store={ props.store } /></OrderDeskModule>,
	contentClass: 'jobDetail',
	onEnter: componentServices.router.requireUser(componentServices.router.requireModule('order-desk'))
}, {
	path: '/order-desk/lead-times',
	component: ({ ...props }) => <OrderDeskModule { ...props}><OrderDeskLeadTimes /></OrderDeskModule>,
	contentClass: 'dashboard multiFamily',
	onEnter: componentServices.router.requireUser(componentServices.router.requireModule('order-desk'))
}, {
	path: '/order-desk',
	onEnter: ({ replace }) => {
		replace('/order-desk/jobs');
		// cancel the route transition
		return false;
	}
}]);

export default OrderDeskModule;